// tslint:disable
/**
 * Dhimahi Webshop API
 * Version 1.0.0, provides API end points for front-end
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: team.dws.jira@dhimahi.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
* 
* @export
* @enum {string}
*/
export enum ApiEndpoint {
    getAccessAndRefreshToken = '/api/auth/request-access-token',
    getEticketList = '/api/account/eticket-list',
    priceList = '/api/price-list',
    promotionCodeCheck = '/api/promotion-code-check',
    refreshAccessToken = '/api/auth/refresh-access-token',
    search = '/api/search',
    searchArtists = '/api/artist-search',
    tdlTokenCheck = '/api/tdl-token-check',
    userLogout = '/api/auth/logout'
}
